export enum PushNotificationStatus {
    Unread = 1,
    Read = 2,
}


